<mat-nav-list class="mc-list-bg-dark mc-list-wrap">
  <a *ngFor="let message of messages$ | async"
    mat-list-item
    [ngClass]="getMessageColorClassName(message)"
    [href]="message.Url"
    target="_blank"
    (click)="onMessageClicked(message, false)"
  >{{ message.Title }}</a>
</mat-nav-list>
